<template>
	<div>
		<div class="container-fluid">
			<div class="row">
				<div class="col-12 ml-0">
					<h4 v-if="module_view_edit == undefined" class="section-title d-flex flex-wrap justify-content-start align-items-center">
			<span class="green h6  m-0 regular mr-2">Program:</span>
			<strong class="text-uppercase h1 m-0">{{course_data.name }}</strong>
			<small>({{ course_duration }})</small>
			<a href="#" class="button d-inline-block ml-3 green-button mt-2 mb-2 edit-button" @click="selectCourse()">Edit info</a>
		</h4>
		<div class="profile-presentation mb-5">
	            <div class="row flex-lg-nowrap">
		            <div class="col-12 col-lg-auto">
			            <p  class="mb-1  active">
							<strong v-if="module_view_edit == undefined" class="h6 text-uppercase">Modules</strong>
							<strong v-if="module_view_edit != undefined" class="h6 text-uppercase">Module</strong><a>
						<img  width="20" src="../../../assets/images/icons/solid/pencil-alt-green.svg" 
				        class="m-1 cursor-pointer" @click="changeEditable()"/></a></p>
						
						

			            <draggable v-model="course_data.modules" @change="dragModule"
			            		:class="{'dont-drag tree modules-tree' : !edit_tree, 'tree modules-tree': edit_tree}" element="ul">
			            	<li  v-for="(module, index) in course_data.modules" 
							:key="index"
							:class="{ 'active' : current_module.id == module.id, 'text-danger' : module.has_errors, 'dont-drag': !edit_tree }"
				            >

				            	<a @click="selectModule(module.id)"><strong v-if="module_view_edit == undefined" class="number">{{ module.order }}. </strong> 
								<strong v-if="module_view_edit != undefined" class="number">1. </strong> 
								<input :disabled="!edit_tree" class="module-input" v-model="module.title">
							
				            		<img v-if="edit_tree"
									 width="20" src="../../../assets/images/icons/solid/times_white.svg" 
				            			class="pr-1 pl-1 red-content m-1" @click.prevent="showModalDeleteModule(module)"/>
				            	</a>

				            	<draggable  v-model="module.lessons" element="ul" @change="dragLesson($event)">
				            
					            	<li v-for="(lesson, index) in module.lessons" 
					            		:class="{ 'active' : current_lesson.id == lesson.id, 'dont-drag': !edit_tree }"
					            		@click.prevent="selectLesson(lesson.id, index)"  :key="lesson.id">
					            		<a href="#" ><span>{{ index + 1 }}: </span>	<input :disabled="!edit_tree" 
										:class="{'lesson-input': edit_tree, 'lesson-input-none': !edit_tree}"
										 v-model="lesson.title">
					            			<img v-if="edit_tree" width="12" src="../../../assets/images/icons/solid/times_white.svg" 
				            					class="pr-1 pl-1 red-content m-1"  
				            					@click.prevent="showModalDeleteLesson(lesson)"/>
					            		</a>
					            	
					            	</li>
									<li v-if="module.has_module_quiz" >
					            		<span>{{module.lessons.length+1}}:</span> Quiz
					            	</li>
					            	<li class="add" slot="footer">
					            		<a  @click="openModalLesson">
						            		<span>Add new lesson</span>
						            	</a>
					            	</li>
				            	</draggable>
				            </li>
			            	<li v-if="module_view_edit == undefined" class="add" slot="footer">
			            		<a  @click="modal_module = !modal_module">
				            		<span >New module</span>
				            	</a>

			            	</li>
			            </draggable>

					</div>
					<div v-if="module_view_edit">
						<slot name="module_view">

						</slot>
					</div>
					<div v-if="module_view_edit == undefined">
					<div  v-if="!show_current_course" class="col-auto flex-fill">
						<generic-module-view
							ref="genericviewmodule"
							:generic_module_view="true"
							:module_languages="module_languages"
							:available_languages="languages_available"
							:current_lesson="current_lesson"
							:current_module="current_module"
							:course_data="course_data"
							@updateLessonName="updateLessonName"
							@removeModalLanguage="removeModalLanguage"
							@saveModule="saveCurrentModule"
							@onChange="onChange"
							@addModalLanguage="addModalLanguage"
							@addLanguageModule="addLanguageModule"
							@currentModuleQuizAdd="currentModuleQuizAdd"
							@currentModuleBaseAdd="currentModuleBaseAdd"
							>
							<div slot="program-agency">
								<h6>Notes</h6>
								<textarea
									class="form-control height-180 mb-2"
									v-model="current_module_comp.notes"
									placeholder="Module Notes"
									v-validate="''"
									name="notes"
								></textarea>
								<hr>
								<program-agency-collapse
									:current_module="current_module_comp"
									:organizationLength="organizationLength"
								></program-agency-collapse>

							</div>
						</generic-module-view>
					</div>
					</div>
		            <div v-if="show_current_course && module_view_edit== undefined" class="col-auto flex-fill">
		            	<div >
				            <div class="row">
					            <div class="col-12">
					            	<div class="h5 bg-title">1. Program info</div>
									<input class="line_holder-2 pointer" type="checkbox"  v-model="course_data.in_class">

									<label class="mw-80">
											<strong>In Class Program</strong>
									</label>
									<div class="mt-1">
										<input class="line_holder-2 pointer" type="checkbox"  v-model="course_data.restrict_order">

										<label class="mw-80">
												<strong>Enable order restriction for modules</strong>
										</label>
									</div>
									<p class="mt-4 mb-0"><label class="mw-80"><strong>Title</strong></label></p>
						        	<div class="input-content">
						            	<input class="input-course-title" placeholder="Program title here..." v-model="course_data.name"/>
						            </div>
						       		
									<p class="mt-4 mb-0"><label class="mw-80"><strong>Description</strong></label></p>
								    <div class="input-content"><textarea v-model="course_data.description"></textarea></div>
									<p class="mt-4 mb-0"><label class="mw-80"><strong>Notes</strong></label></p>
								    <div class="input-content"><textarea v-model="course_data.notes"></textarea></div>
									<p class="mt-4 mb-0"><label class="mw-80"><strong>Program Certification Text</strong></label></p>
								    <div class="input-content"><textarea v-model="course_data.certificate_text"></textarea></div>

									<!-- <div class="h5 bg-title">2. Tags</div>
									
				            		<tags :entity_str="'App\\Models\\Course'" 
				            				:entity="course_data" ref="tags"></tags> -->

								</div>
				            </div>
				            <div class="row">
				            	<div class="col-12 col-lg-6">
				            		<label class="d-block mb-2">Current image</label>
				            		<p><img :src="course_data.image" /></p>
				            	</div>
				            	<div class="col-12 col-lg-6">	
						            <picture-input 
								      ref="pictureInput"
								      accept="image/jpeg,image/png" 
								      size="10" 
								      button-class="button"
								      :custom-strings="{
								        upload: '<h1>Bummer!</h1>',
								        drag: 'Drag or click to upload an image'
								      }"
								      @change="onChange">
								    </picture-input>
					            </div>
				            </div>

				            <div class="row mt-3 justify-content-end">
					            <div class="col-auto">
								    <button type="button" class="button large-button gray-content" @click="saveCourse">Save and continue</button>
					            	<button class="button large-button" @click="submit">Finish</button>
					            </div>
				            </div>
		            	</div>
					</div>
					</div>
	            </div>
	        </div>
				
			</div>


		</div>
		

	    <!-- MODALS -->

	    <!-- SELECT MODULE MODAL -->
	    <b-modal v-model="modal_lesson" title="Add lesson" @shown="select_existing_lesson = false" size="lg" cancel-title="Close" @cancel="resetModalModuleLesson" @ok="resetModalModuleLesson">
		<!-- select new module or existing one -->
		
			<p class="mb-2">
				<button @click="addLesson()" class="bold button green-content large-button text-uppercase">Add a new lesson</button>
			</p>
			<p>...Or select from existing ones:</p>

			<table-view-course :table_headers="['ID','Lessons','','Modules','Created on','']"
			:table_body_data="existing_lessons" 
			:pagination_existing_modules="pagination_existing_lessons"
			:show_add_module="true"
			:table_view="'lesson'"
			@addExistingModule="addExistingLesson"
			@setPageExistingModules="setPageExistingLessons"
			@keyUpSearchExistingModules="keyUpSearchExistingLesson">
			</table-view-course>
		</b-modal>

		<!-- SELECT LESSON MODULE -->
		<div v-if="module_view_edit == undefined || module_view_edit == true ">
		<b-modal v-model="modal_module" title="Add module" @shown="select_existing_module = false" size="lg" cancel-title="Close">
		
		
			<p v-if="!course_data.providers_assigned" class="mb-2">
				<button @click="addModule()" class="bold button green-content large-button text-uppercase">Add a new module</button>
			</p>
			<p v-if="!course_data.providers_assigned">...Or select from existing ones:</p>

			<table-view-course :table_headers="['ID','Module','Quiz','Notes','Lessons','Programs','Agencies','Created on','']"
			:table_body_data="existing_modules" 
			:pagination_existing_modules="pagination_existing_modules"
			:show_add_module="true"
			:table_view="'module'"
			@addExistingModule="addExistingModule"
			@setPageExistingModules="setPageExistingModules"
			@keyUpSearchExistingModules="keyUpSearchExistingModules"></table-view-course>

		</b-modal>
		</div>
		<!-- DELETE MODULE MODAL -->
		<b-modal v-model="show_modal_delete_module" title="Delete Module" @ok="deleteModule" cancel-title="No" ok-title="Yes">
	    	<div v-if="module_to_delete != null">
				<p class="mb-2">
					Are you sure you want to delete the module {{ module_to_delete.title }}?
				</p>
			</div>
		</b-modal>

		<!-- DELETE MODULE LESSON -->
		<b-modal v-model="show_modal_delete_lesson" title="Delete Lesson" @ok="deleteLesson" cancel-title="Cancel" ok-title="Delete">
	    	<div v-if="lesson_to_delete != null || lesson_to_delete != undefined">
				<p class="mb-2" v-if="lesson_module_relationship_warning">
					Deleting {{ lesson_to_delete.title}} will affect the <b>Module Base Relationship</b>
				</p>

				<p v-else class="mb-2">
					Are you sure you want to delete the lesson {{ lesson_to_delete.title}}?
				</p>
			</div>
		</b-modal>
	</div>
</template>

<script>
	import PictureInput from 'vue-picture-input';
	import GenericModuleView from '../SharedViews/GenericModuleView'
	import ProgramLessonView from '../SharedViews/ProgramLessonView'
	import ProgramAgencyCollapse from '../SharedViews/ProgramAgencyCollapse'
	import { EventBus } from './../../../event_bus.js';
	import MixinSME from '../MixinSME'
	export default {
		mixins: [MixinSME],
		props:[
			'module_view_edit','current_module_view_id','module_view_language'
		],
		data : function(){
			return {
				edit_tree:false,
				generic_module_view:true,
				api_base: this.config.API_BASE,
				id : this.$route.params.id,
				course_data : {
					image_changed : false,
					modules : []
				},
				current_module : { id : 0 },
				current_lesson : { id : 0 },

				modal_lesson : false,
				modal_module : false,

				show_current_module : false,
				show_current_lesson : false,
				show_current_course : true,
				show_module_tags : false,

				select_existing_module : false,
				selected_existing_module : null,
				existing_modules : [],
				select_existing_lesson : false,
				selected_existing_lesson : null,
				existing_lessons : [],

				dropzoneOptions: {
					url : this.config.UPLOAD_TINCAN_FILE,
					thumbnailWidth: 50,
					maxFilesize: 500,
					maxFiles : 1,
					timeout : 300000,
					addRemoveLinks : true,
					headers : {
						'Autrollization' : localStorage.getItem('token')
					}
			    },
			    attachmentsDropzoneOptions: {
					url : this.config.UPLOAD_ATTACHMENT_FILES,
					thumbnailWidth: 50,
					maxFilesize: 500,
					maxFiles : 100,
					addRemoveLinks : true,
					timeout : 300000,
					headers : {
						'Autrollization' : localStorage.getItem('token')
					}
			    },

			    pagination_existing_modules : {
			    	current_page : 0,
					total : 0,
					per_page : 0,
					from : 0,
					to : 0
			    },
			    search_existing_modules : '',
			    timeout_input_existing_modules : null,
			    pagination_existing_lessons : {
			    	current_page : 0,
					total : 0,
					per_page : 0,
					from : 0,
					to : 0
			    },
				selected_language:null
				,
				
			    search_existing_lessons : '',
			    timeout_input_existing_lessons : null,
			    show_modal_delete_module : false,
			    module_to_delete : null,
			    show_modal_delete_lesson : false,
			    lesson_to_delete : null,
				languages_all:[],
				module_languages:[],
				languages_available:[],
				temp_module_title: 'New Module Created!',
				temp_lesson_title: 'Lesson created! Click me to edit',
				module_lesson_search_key:'',
				lesson_module_relationship_warning: false

			}
		},

		computed : {
			course_duration: function(){
				let temp_dur = 0;
				for(let i in this.course_data.modules){
					if(this.course_data.modules[i].lessons){
						for(let k in this.course_data.modules[i].lessons){
							if(this.course_data.modules[i].lessons[k].duration_int != null && this.course_data.modules[i].lessons[k].duration_int != ''){
								temp_dur+= parseInt(this.course_data.modules[i].lessons[k].duration_int)
							}
						}
					}
				}
				 this.course_data.duration = temp_dur
			
				return this.secondsToHms(this.course_data.duration)
			},
			existing_lessons_update: function(){
				return this.existing_lessons
			},
			current_module_comp : function(){
				return this.current_module
				
			},
			current_lesson_comp : function(){
				return this.current_lesson;
			},
			organizationLength: function(){
				if(this.current_module.organizations){
					return Object.keys(this.current_module.organizations).length

				}else{
					return 0
				}
			},

		},
		watch:{
			module_languages: function(val){
				//If module has languages we remove from language list
				for(let i in val){
					for(let z in this.languages_available){
						if(val[i].key == this.languages_available[z].code_2){
							this.languages_available.splice(z,1)
						}
					}
				}
			},
		},
		components: {
			PictureInput,
			GenericModuleView,
			ProgramLessonView,
			ProgramAgencyCollapse

		},
		created : function(){
			if(this.module_view_edit == undefined){
				this.getCourse(true);
			}
			this.refreshDuration();
			if(this.module_view_edit !=undefined){
				this.getExistingModulesModuleView()
			}else{
				this.getExistingModules()
			}
		},
		mounted: function(){
			 EventBus.$on('update_module', (module) =>{
				this.current_module = module
			})
			 EventBus.$on('addLanguageModuleTrigger', (language) =>{
				 this.addLanguageModule(language)
			})
			 EventBus.$on('add_language', (lang) =>{
				this.languages_available.push({code_2:lang.key, name:lang.value})
		
			})
			EventBus.$on('selected_laguage_change', (language) => {
					this.selected_language = language
			});
			 EventBus.$on('updateModuleQuiz', (val) => {
				 if(val == 1 || val == true){
					this.current_module.has_quiz = true
				 }
				  if(val ==0 || val == false){
					//uncheck current module course
					 for(let i in this.current_module.lessons){
						 if(this.current_module.lessons[i].has_quiz == true){
							 return
						 }
					 }
					this.current_module.has_quiz = false
				}
			});
		},
		methods : {
			currentModuleQuizAdd: function(id){
				this.current_module.quiz_module_id = id
			},
			currentModuleBaseAdd: function(id){
				this.current_module.base_module_id = id
			},
			resetModalModuleLesson: function(){
				EventBus.$emit('reset_seach_key')
				this.module_lesson_search_key = ''
				this.getCourse(true);
				this.getExistingModules();

				console.log('MEGA RESET');
				window.location.reload();
			},
			changeEditable: function(){
				if(this.edit_tree){
					if(this.module_view_edit != undefined){
						this.saveCurrentModule()
					}else{
						this.saveCourse()

					}
				}
				EventBus.$emit('edit_tree', this.edit_tree)
				EventBus.$emit('update_module', this.current_module)
				this.edit_tree = !this.edit_tree;
				
			},
			getCourse : function(page_loading){
				if(this.module_view_edit != undefined){
					return
				}
				var params = {
					id : this.id,
					filters : {
						full : true,
						page_loading : page_loading
					}
				}
			

				this.$store.dispatch('getCourse', params).then((res) => {
					let not_null_response = this.nameNullChecker(res.data.data.modules)
					res.data.data.modules = not_null_response
					this.course_data = res.data.data;
				}).catch((error) => {
					console.log(error);
				});
			},
			async available_languages() {
				var params = { available_in_system: 1 };

				this.$store.dispatch("getLanguages", params).then(res => {
					this.languages_all = res.data.data;
					let temp_less = [];
					for (let i in this.languages_all) {
						if (
						this.languages_all[i][0].available_in_system == 1
						) {
						temp_less.push(this.languages_all[i][0]);
						}
					}
					this.languages_available = temp_less
					this.module_available_languages();
				});
				
			},
			async module_available_languages () {
				if (this.current_module == undefined) {
					return;
				}
				let keys = [];
				let full_language = [];
				let currentModuleName = this.current_module.name ? this.current_module.name : {};
				keys.push(Object.keys(currentModuleName));
				for (let i in this.languages_available) {
					for (let k in keys[0]) {
					if (keys[0][k] == this.languages_available[i].code_2) {
						let temp = { key: keys[0][k], value: this.languages_available[i].name };
						full_language.push(temp);
					}
					}
				}
				//If module has languages we remove from language list
				for(let i in full_language){
					for(let z in this.languages_available){
						if(full_language[i].key == this.languages_available[z].code_2){
							this.languages_available.splice(z,1)
						}
					}
				}
			
				this.module_languages = full_language
				},
			nameNullChecker: function(item){
				if(Array.isArray(item)){
					for(let i in item){
						if(item[i].name == null){
							item[i].name = {}
						}
						if(item[i].description == null){
							item[i].description = {}
							
						}
					}
					return item
				}else{
					if(item.name == null){
						item.name = ''
					}
					if(item.description == null){
						item.description = ''
					}
					return item

				}


			},
		
			refreshDuration : function(){
				if(this.module_view_edit != undefined){
					return
				}
				var params = {
					id : this.id
				}

				this.$store.dispatch('getCourse', params).then((res) => {
					this.course_data.duration_formatted = res.data.data.duration_formatted;
				}).catch((error) => {
					console.log(error);
				});
			},
			getExistingModulesModuleView: function(){
					var params ={
						id: this.current_module_view_id,
						filters:{
							full:true,
							page_loading:true,
							exclude : ['lessons_modules', 'lessons_has_tincan','quiz_lesson'],
						}
					}
					this.$store.dispatch('getModule', params).then((res) => {
					
						
						//this.existing_modules = res.data.data
						//this.existing_lessons = res.data.data.lessons
						this.course_data.modules = []
						this.current_module = res.data.data
						this.course_data.modules.push(res.data.data)
						this.available_languages();
						//EventBus.$emit('update_program_lesson',res.data.data)
					})

			},
			getExistingModules : function(key_search){
				if(key_search == undefined){
					this.module_lesson_search_key = ''
				}else{
					this.module_lesson_search_key = key_search
				}
					var params = { 
						filters : { 
							full : true, 
							in_course : this.id,
							page : this.pagination_existing_modules.current_page,
							search : this.module_lesson_search_key,
                            include_archived: 0
						}
					}
					this.$store.dispatch('getModules', params).then((res) => {
						this.existing_modules = res.data.data;
						this.pagination_existing_modules = res.data.meta;
					});
				
			},
			getExistingLessons : function(key_word){
				if(key_word== undefined){
					key_word = ''
				}else{
					this.module_lesson_search_key = key_word
				}
				
				var params = {
					filters : {
						in_module : this.current_module.id,
						page : this.pagination_existing_lessons.current_page,
						search : this.module_lesson_search_key,
						include_archived: 0
					}
				}
				this.$store.dispatch('getLessons', params).then((res) => {
					this.existing_lessons = res.data.data;

					this.pagination_existing_lessons = res.data.meta;
				});
			},
			selectExistingModule : function(){
				this.current_module = this.selected_existing_module;
				this.nullChecker(this.selected_existing_module)
				this.available_languages()
			
			},
			addLanguageModule:function(language){
				this.current_module.name[language.code_2] = 'New  '+ language.name + ' Name'
        
       			 this.current_module.description[language.code_2] ='';
				// Now we will update the available languages
				this.available_languages();
				EventBus.$emit('addLanguageModule',language)
				this.$nextTick(() => {
					this.$forceUpdate(); 
				});
			},
			addModule : function(){
				
				//save the new module in the database
				var module_info = {
					title : this.temp_module_title,
					name:{},
					description : {},
					filters : {
						course_id : this.id
					}
				}

				this.$store.dispatch('createModule', module_info).then((res) => {
					this.nullChecker(res.data.module)
					if(res.data.module.name == ''){
						res.data.module.name = {}
					}
					if(res.data.module.description == ''){
						res.data.module.description = {}
					}
					if(res.data.module.name == ''){
						res.data.module.name = {}
					}
					res.data.module.courses = [];
					res.data.module.lessons = [];
					this.course_data.modules.push(res.data.module);
					this.modal_module = false;
					this.refreshDuration();
					this.selectModule(res.data.module.id);
				}).catch((error) => {
					console.log(error);
				});				
			},

			addExistingModule : function(module){
				var params = {
					id : this.id,
					module_id : module.id,
					is_quiz_enabled: module.has_module_quiz,
				}
				this.$store.dispatch('addModuleToCourse', params).then((res) => {
					module.order = res.data.order;
					this.getCourse();
					this.getExistingModules(this.pagination_existing_modules.current_page);
					this.refreshDuration();
					this.selectModule(module.id);
					// this.course_data.modules.push(module);
					// this.select_existing_module = false;
					// this.refreshDuration();
					// this.getExistingModules(this.pagination_existing_modules.current_page);
				}).catch((error) => {
					console.log(error);
				});	
				
			},

			selectModule : function(index){
				if((index == this.current_module.id) && (this.edit_tree != true)){
			
					this.current_module = { id : 0 }
					this.showCurrentCourse()
					return
				}
				if((index == this.current_module.id && this.edit_tree == true)){
					return
				}

				this.showCurrentModule();

				for(var i in this.course_data.modules){
					if(this.course_data.modules[i].id == index){
						if(this.course_data.modules[i].description == null){
							this.course_data.modules[i].description = ''
						}
						this.nullChecker(this.course_data.modules[i])
						this.current_module = this.course_data.modules[i];
						EventBus.$emit('update_program_lesson',this.current_module)
						this.available_languages()
						
						
						break;
					}
				}
				
			},

			selectCourse : function(){

				this.current_module = { id : 0 };
				this.current_lesson = { id : 0 };

				this.showCurrentCourse();

			},

			addLesson : function(){

				//save the new module in the database
				var temp_lang = []
				if(this.module_view_edit == true){
					temp_lang = this.module_view_language
				}else{
					temp_lang = this.module_languages
				}
				if(temp_lang.length == 0){
					this.modal_lesson = false
					this.$snotify.error('Please, First Add Language')
					return
				}
				var lesson_info = {
					title: this.temp_lesson_title,
					name : {
						[temp_lang[0].key] : ''
					},
					description : {
						[temp_lang[0].key] : ''
					},
					tincan : null,
					attachtments : null,
					filters : {
						module_id : this.current_module.id
					}
				}

				this.$store.dispatch('createLesson', lesson_info).then((res) => {
					if(this.module_view_edit !=undefined){
						this.nullChecker(res.data.lesson)
						res.data.lesson.image = {}
						res.data.lesson.tincan_download_url = {}
						res.data.lesson.tincan_url = {}
						this.course_data.modules[0].lessons.push(res.data.lesson)
						this.getExistingModulesModuleView()

					}else{
						res.data.lesson.image = {}
						this.current_module.lessons.push(res.data.lesson);
						//this.selectLesson(res.data.lesson.id);
						EventBus.$emit('update_program_lesson', this.current_module)
						this.refreshDuration();
						this.modal_lesson = false;
						
					}
					 this.$nextTick(() => {
						// Add the component back in
						this.$forceUpdate(); 
					});
					

				}).catch((error) => {
					console.log(error);
				});								
			},
			nullChecker: function(item){
				let keys = Object.keys(item)
				if((keys != null || keys !='') && item != null){
					for(let i in keys){
						if(item[keys[i]] == null ){
							item[keys[i]] = ''
						}
					}

				}
				
			},
			addExistingLesson : function(lesson){

				var params = {
					id : this.current_module.id,
					lesson_id : lesson.id
				}
				if(lesson.description == null){
					lesson.description = {}
					lesson.description.EN = ''
				}
				this.$store.dispatch('addLessonToModule', params).then((res) => {
					lesson.order = res.data.order;
					if(this.module_view_edit !=undefined){
						
						this.course_data.modules[0].lessons.push(lesson)
						if(this.module_view_edit !=undefined){
							this.getExistingModulesModuleView()
						}else{
							this.getExistingModules()
						}
					}else{
						this.current_module.lessons.push(lesson);

						this.select_existing_lesson = false;

						//this.selectLesson(lesson.id);
						this.refreshDuration();
						this.getExistingLessons(this.pagination_existing_lessons.current_page);

					}
				}).catch((error) => {
					console.log(error);
				});	

				
			},

			selectLesson : function(index, lesson_number){

				if(this.show_modal_delete_lesson == true || this.edit_tree == true){
					return
				}
				this.showCurrentLesson();
				
				for(var i in this.current_module.lessons){
					if(this.current_module.lessons[i].id == index){
						if(this.selected_language != null){
							if(this.module_view_edit == undefined){
								this.$refs.genericviewmodule.openLessonGeneric(lesson_number)
							}
							if(this.module_view_edit == true){
							 EventBus.$emit('openLesson', lesson_number)

							}
							break
						}
						
					}
				}
			},

			showCurrentLesson : function(){
				this.show_current_course = false;
				this.show_current_lesson = true;
				this.show_current_module = false;
			},

			showCurrentModule : function(){
				this.show_current_course = false;
				this.show_current_lesson = false;
				this.show_current_module = true;
			},

			showCurrentCourse : function(){
				this.show_current_course = true;
				this.show_current_lesson = false;
				this.show_current_module = false;
			},	
			submit : function(){

				this.message_error = '';
				this.hide_button_submit = true;

				this.$validator.validateAll().then((result) => {

					// this.$snotify.success('Course saved successfully');

					// this.$router.push({ name : 'sme.courses.index'});
					this.course_data.in_class = this.course_data.in_class ? 1 : 0
					this.course_data.restrict_order = this.course_data.restrict_order ? 1 : 0;
					this.$store.dispatch('createCourseFull', this.course_data).then((res) => {
							

						// this.hide_button_submit = false;
					}).catch((error) => {
						// this.hide_button_submit = false;

						this.message_error = 'There was an error while editing the course';
					});
				});		
			},
			saveCourse : function(){
				this.course_data.in_class = this.course_data.in_class ? 1 : 0
				this.course_data.restrict_order = this.course_data.restrict_order ? 1 : 0;
				this.$store.dispatch('editCourse', this.course_data).then((res) => {
					
				}).catch((error) => {
					console.log(error);
				});
			},
			tincanUploaded : function(file, response){
				this.current_lesson.has_tincan = response.lesson.has_tincan;
			},
			removeTincan : function(){
				this.$store.dispatch('removeTincan', { id : this.current_lesson.id }).then((res) => {
					this.current_lesson.has_tincan = res.data.lesson.has_tincan;
				}).catch((error) => {
					console.log(error);
				})
			},

			attachmentUploaded : function(file, response){
				this.current_lesson.attachments = response.lesson.attachments;
			},
			removeAttachment : function(attachment_id){

				var params = { id : this.current_lesson.id, attachment_id : attachment_id };

				this.$store.dispatch('removeAttachment', params).then((res) => {
					this.current_lesson.attachments = res.data.lesson.attachments;
				}).catch((error) => {
					console.log(error);
				});
			},
			downloadAttachment : function(attachment_id){
				var params = { id : this.current_lesson.id, attachment_id : attachment_id };

				this.$store.dispatch('downloadAttachment', params).then((res) => {
					this.current_lesson.attachments = res.data.lesson.attachments;
				}).catch((error) => {
					console.log(error);
				});
			},
			updateLessonName: function(name, id){
				this.current_module.lessons.find(x => x.id === id).title = name
			},
			saveCurrentModule: function(){
				//Module Title Check
				if(this.current_module.title == this.temp_module_title){
					if('EN' in this.current_module.name){
						this.current_module.title = this.current_module.name['EN']
					}
				}
				 //Lesson Title Check
				for(let i in this.current_module.lessons){
					if(this.current_module.lessons[i].title == this.temp_lesson_title){
						if('EN' in this.current_module.lessons[i].name){
								this.current_module.lessons[i].title = this.current_module.lessons[i].name['EN']
							}
					}
				}
				this.$store.dispatch('editModule', this.current_module).then((res) => {
					this.addCategoryModule()
					
				}).catch((error) => {
					this.$snotify.error('Error from server');
				});
			},
			addCategoryModule(){
				var params = {
					id: this.current_module.id,
					category_id: this.current_module.sme_categories.map(elem => {return elem.id} )
					
				}
				console.log(params)
				this.$store.dispatch('editModuleCategory', params).then((res) => {

				}).catch((error) => {
					this.$snotify.error('Error from server');
					this.created();
				});
			},
			saveCurrentLesson : function(){

				this.current_lesson.groups = this.$refs.tagsLesson.groups;

				if(this.current_lesson.title = this.temp_lesson_title){
					if('EN' in this.current_lesson.name){
						this.current_lesson.title = this.current_lesson.name['EN']
					}
				}
				this.$store.dispatch('editLesson', this.current_lesson).then((res) => {
					this.refreshDuration();
					this.$snotify.success(res.data.message);
				}).catch((error) => {
					this.$snotify.error('Error from server');
				});
			},
			onChange : function(image) {
				if (image) {
					
					var params = {
						id : this.course_data.id,
						image : image
					}

					this.$store.dispatch('updateCourseImage', params).then((res) => {
						// this.$refs.pictureInput.removeImage();
						this.$snotify.success('Image updated successfully');
						this.course_data.image = image;
					});
				}

			},
			onChangeModule : function(image){
				if(image){
					

					var params = {
						id : this.current_module.id,
						image : image
					}

					this.$store.dispatch('updateModuleImage', params).then((res) => {
						this.$refs.pictureInputModule.removeImage();
						this.current_module.image = image;
						this.$snotify.success('Image updated successfully');
					});
				}
			},

			openModalLesson : function(){
				this.modal_lesson = true;

				this.getExistingLessons();
			},

			setPageExistingModules : function(obj){
				this.pagination_existing_modules.current_page = obj.page;
				this.module_lesson_search_key = obj.search
				this.getExistingModules(this.module_lesson_search_key);
			},

			setPageExistingLessons : function(obj){
				this.pagination_existing_lessons.current_page = obj.page;
				this.module_lesson_search_key = obj.search
				this.getExistingLessons();
			},

			keyUpSearchExistingLesson : function(key_word){
				clearTimeout(this.timeout_input_existing_lessons);

				this.timeout_input_existing_lessons = setTimeout( () => {
					this.getExistingLessons(key_word);
				}, 500)
			},

			keyUpSearchExistingModules : function(key_word){
				clearTimeout(this.timeout_input_existing_modules);

				this.timeout_input_existing_modules = setTimeout( () => {
					this.getExistingModules(key_word);
				}, 500)
			},
			showModalDeleteModule : function(module){
				this.module_to_delete = module;
				this.show_modal_delete_module = true;
			},
			deleteModule : function(){
				var params = {
					id : this.id,
					module_id : this.module_to_delete.id
				}

				this.$store.dispatch('deleteModuleCourse', params).then((res) => {
	
					this.getCourse();
					if(this.module_view_edit !=undefined){
							this.getExistingModulesModuleView()
						}else{
							this.getExistingModules()
						}
					this.refreshDuration();
					this.module_to_delete = false;
					this.show_current_course = true

				}).catch((error) => {
					console.log(error);
				});
			},
			showModalDeleteLesson : function(lesson){
				//if lesson has quiz and current module has base_id we warn user 
				if(lesson.has_quiz == 1 && (!!this.current_module.base_module_id)){
					this.lesson_module_relationship_warning = true
				}
				this.lesson_to_delete = lesson;
				this.show_modal_delete_lesson = true;
			},
			deleteLesson : function(){
				this.lesson_module_relationship_warning = false
				this.show_modal_delete_lesson = false
				var params = {
					id : this.current_module.id,
					lesson_id : this.lesson_to_delete.id
				}

				this.$store.dispatch('deleteLessonCourse', params).then((res) => {
				
					this.course_data.modules[0].lessons = this.course_data.modules[0].lessons.filter((elem, index)=>{
						return elem.id != this.lesson_to_delete.id
					})
					this.getCourse();
					this.refreshDuration();
					if(this.module_view_edit !=undefined){
							this.getExistingModulesModuleView()
					}else{
						this.getExistingModules()
					}

				}).catch((error) => {
					console.log(error);
				});
			},

			dragModule : function(a){

				if(a.moved){
					var element = a.moved.element;
					var new_index = a.moved.newIndex;
					var old_index = a.moved.oldIndex;

					
					var params = {
						id : this.id,
						module_id : element.id,
						filters : {
							new_index : new_index,
							old_index : old_index
						}
						
					}

					this.$store.dispatch('changeModuleOrder', params).then((res) => {
						if(this.module_view_edit == undefined){
							this.getCourse(false)
						}
					}).catch((error) => {
						console.log(error);
					});

				}
			},
			updateLessonOrder: function(){
				var params ={
						id: this.current_module.id,
						filters:{
							full:true,
							page_loading:true
						}
					}
					this.$store.dispatch('getModule', params).then((res) => {
					
						
						// this.existing_modules = res.data.data
						// this.existing_lessons = res.data.data.lessons
						// this.current_module = res.data.data
						// this.course_data.modules.push(res.data.data)
						EventBus.$emit('update_program_lesson',res.data.data)
					})

			},

			dragLesson : function(a, b){

				if(a.moved){
					var element = a.moved.element;

					var new_index = a.moved.newIndex;
					var old_index = a.moved.oldIndex;

					element.order = new_index+1;					

					var params = {
						id : this.current_module.id,
						lesson_id : element.id,
						filters : {
							new_index : new_index,
							old_index : old_index
						}
					}


					this.$store.dispatch('changeLessonOrder', params).then((res) => {
						if(this.module_view_edit !=undefined){
							if(this.module_view_edit !=undefined){
							this.getExistingModulesModuleView()
						}else{
							this.getExistingModules()
						}
							this.updateLessonOrder();

						}else{
							
							this.getCourse(false);
							this.updateLessonOrder();
						}
					}).catch((error) => {
						console.log(error);
					});

				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/sme/courses/SMECourseEditComponent.vue